import { apiCall, ApiConfig } from '../../config/api'
import { AsnState } from '../../interfaces/Asn/AsnState'
import { getAsnStateAction } from '../actions/asnStateActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_ASN_STATE } from '../types/asnStateActionsTypes'
import { DataGridElements } from '../../interfaces/index'

export function* getAsnStatesAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<AsnState>> =
      yield call(apiCall, 'GET', `${ApiConfig.AsnStateApi}?pageSize=50`)
    if (status === 200) {
      yield put(getAsnStateAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getAsnStateAction([], serverError.message))
  }
}

export function* watchGetAsnStatesAsync() {
  yield takeEvery(GET_ASN_STATE, getAsnStatesAsync)
}
